module.exports = __webpack_public_path__ + "62abdca584828e40e28735bc7ec36241.jpg";